export const endPointskey="endPoints";